import { csx } from '@vtex/admin-ui'
import React, { ReactNode } from 'react'

type BottomSliderModalContentProps = {
  children: ReactNode
}

export const BottomSliderModalContent = ({
  children,
}: BottomSliderModalContentProps) => {
  return (
    <div className={csx({ overflow: 'auto', maxHeight: '90vh' })}>
      {children}
    </div>
  )
}
